import {
  DictionaryAutocomplete,
  useAutocompleteSource,
  useStaticListSource,
} from '@eas/common-web';
import { EvidenceApiUrl, ProcessState } from '@enums';
import { RequestNonStandardState } from '@models';

export function useProcessStates() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: ProcessState.CREATED, name: 'Vytvořený' },
    { id: ProcessState.FAILED, name: 'Selhal' },
    { id: ProcessState.RUNNING, name: 'Běžící' },
    { id: ProcessState.PROCESSED, name: 'Zpracován' },
    { id: ProcessState.PROCESSED_WITH_FAILURES, name: 'Zpracován s chybami' },
  ]);
}

export function useNonStandardStates() {
  return useAutocompleteSource<RequestNonStandardState>({
    url: EvidenceApiUrl.NON_STANDARD_STATE_AUTOCOMPLETE,
  });
}
